// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__MOJDa","mobile":"styles_mobile__S3vZE"};